import { render } from "./WhatsAppDetailPage.vue?vue&type=template&id=0f8cf7e2"
import script from "./WhatsAppDetailPage.vue?vue&type=script&lang=js"
export * from "./WhatsAppDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__